
import { Button } from "@/components/ui/button";
import FooterAr from "@/components/FooterAr";
import HeaderAr from "@/components/HeaderAr";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ContactAr = () => {
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Arabic contact form submitted to contact@wearemusicnation.ae");
  };

  return (
    <div className="min-h-screen bg-musicBlack" dir="rtl">
      <HeaderAr />
      <main className="pt-24">
        {/* Hero section */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-r from-musicBlack to-musicBlack/90"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-musicBlack"></div>
            <img 
              src="https://images.unsplash.com/photo-1470813740244-df37b8c1edcb" 
              alt="تواصل" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="relative z-10 editorial-container">
            <div className="max-w-3xl">
              <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4">التواصل والانضمام</h1>
              <h2 className="font-serif text-2xl md:text-3xl text-musicRed mb-6">تواصل مع الصوت الرسمي لحقوق الموسيقى في دولة الإمارات</h2>
              <p className="font-sans text-lg mb-8 text-musicWhite/90">
                سواء كنت مبدعاً تتطلع لحماية عملك، أو شركة تسعى للحصول على ترخيص مناسب، 
                أو لديك أسئلة حول حقوق الموسيقى في دولة الإمارات، فريقنا هنا لمساعدتك.
              </p>
            </div>
          </div>
        </section>
        
        {/* Contact form section */}
        <section className="py-24 bg-black">
          <div className="editorial-container">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div>
                <h2 className="font-serif text-3xl font-bold mb-6">تواصل معنا</h2>
                <p className="font-sans text-musicGrey mb-8">
                  املأ النموذج وسيرد فريقنا خلال 24 ساعة.
                </p>
                
                <form 
                  name="contact-ar"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  onSubmit={handleFormSubmit}
                  className="space-y-6"
                >
                  <input type="hidden" name="bot-field" />
                  <input type="hidden" name="form-name" value="contact-ar" />
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <Label htmlFor="name" className="text-musicWhite font-sans">الاسم الكامل</Label>
                      <Input 
                        id="name" 
                        name="name"
                        placeholder="اسمك" 
                        className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="email" className="text-musicWhite font-sans">عنوان البريد الإلكتروني</Label>
                      <Input 
                        id="email" 
                        name="email"
                        type="email" 
                        placeholder="بريدك الإلكتروني" 
                        className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="inquiry-type" className="text-musicWhite font-sans">نوع الاستفسار</Label>
                    <Select name="inquiry-type">
                      <SelectTrigger className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed">
                        <SelectValue placeholder="اختر نوع الاستفسار" />
                      </SelectTrigger>
                      <SelectContent className="bg-musicBlack border-musicGrey/30 text-musicWhite">
                        <SelectItem value="creator">تسجيل المبدع</SelectItem>
                        <SelectItem value="business">ترخيص الأعمال</SelectItem>
                        <SelectItem value="legal">سؤال قانوني</SelectItem>
                        <SelectItem value="media">استفسار إعلامي</SelectItem>
                        <SelectItem value="other">أخرى</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="message" className="text-musicWhite font-sans">الرسالة</Label>
                    <Textarea 
                      id="message" 
                      name="message"
                      placeholder="كيف يمكننا مساعدتك؟" 
                      className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed min-h-[150px]"
                    />
                  </div>
                  
                  <Button type="submit" className="cta-button w-full md:w-auto">إرسال الاستفسار</Button>
                </form>
              </div>
              
              <div>
                <h2 className="font-serif text-3xl font-bold mb-6">التواصل المباشر</h2>
                <div className="space-y-8">
                  <div>
                    <h3 className="font-serif text-xl font-medium text-musicRed mb-3">معلومات الاتصال</h3>
                    <p className="font-sans text-musicGrey mb-2">
                      <strong className="text-musicWhite">البريد الإلكتروني:</strong> contact@wearemusicnation.ae
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterAr />
    </div>
  );
};

export default ContactAr;
